import React, { useEffect, useState } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { gsap, CSSPlugin, Expo } from 'gsap'

const Landing = ({ showContent }) => {

    const [counter, setCounter] = useState(0)

    useEffect(() => {
        AOS.init()

        gsap.registerPlugin(CSSPlugin)
        const count = setInterval(() => {
            document.body.style.overflow = 'hidden';
            setCounter(counter => {
                // eslint-disable-next-line no-unused-expressions
                counter < 100 ? setCounter(counter + 1) : (
                    // eslint-disable-next-line no-sequences
                    clearInterval(count),
                    setCounter(100),
                    reveal()
                )
            })
        }, 25)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const reveal = () => {

        const t1 = gsap.timeline({
            onComplete: () => {
                document.body.style.overflow = 'visible';
                showContent()
            }
        })
        t1
            .to('.follow', { duration: 1.2, width: '100%', ease: Expo.easeInOut }, '+=0.7')
            .to('.hide', { duration: 0.3, opacity: 0 })
            .to('.hide', { duration: 0.1, display: 'none' })
            .to('.follow', { duration: 0.7, height: '100%', ease: Expo.easeInOut }, '+=0.5')
            .to('.content', { duration: 0.7, width: '100%', ease: Expo.easeInOut })
            .to('.title-lines', { duration: 0.1, display: 'block' })
            .to('.title-lines', { duration: 0.6, opacity: 1, stagger: 0.15, ease: Expo.easeInOut })
            .to('.logo', { duration: 0.6, opacity: 1, stagger: 0.15, ease: Expo.easeInOut })
            .to('#scroll, li', { duration: 0.4, opacity: 1 }, '-=0.3')
            .to('main', { duration: 0.1, marginBottom: '15vw' })
    }


    return (
        <main >
            <div className='loading'>
                <div className="follow"></div>
                <div className='hide' id='progress-bar' style={{ width: counter + '%' }} ></div>
                <p id='count' className='hide'> {counter}% </p>
            </div>

            <div className='content'>
                <div id='scroll'>Welcome To The Chill Zone</div>

                <section>
                    <p className='title-lines'> <span>“</span>C<span>o</span>DE<span>R</span>,</p>
                    <p className='title-lines'>  DESI<span>G</span>NE<span>R</span>, <span>A</span>RTI<span>ST</span>,  </p>
                    <p className='title-lines'>  <span>FR</span>ONTEND </p>
                    <p className='title-lines'>DE<span>V</span>ELOP<span>ER.”</span></p>
                </section>
                <nav>
                    <ul>
                        <li>AGNI.S()</li>
                    </ul>
                </nav>
            </div>
        </main >
    )
}

export default Landing